/* Fovory bag (sections/cart-drawer.liquid).
   Minimog keeps the cart logic (m-cart-items re-renders the three blocks after every change);
   this file adds what sits on top: "Just added", the deal countdown, delivery dates, the dispatch
   cut-off, quantity buttons, suggestions with one-tap add, focus handling and swipe-to-close. */
(() => {
  'use strict';

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const fill = (s, o) => String(s || '').replace(/\[(\w)\]/g, (m, k) => (o[k] != null ? o[k] : m));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const drawer = () => document.getElementById('MinimogCartDrawer');
  const isOpen = () => { const d = drawer(); return !!d && d.classList.contains('m-cart-drawer--active'); };
  const lang = (document.documentElement.lang || 'en').toLowerCase();
  const locale = lang.startsWith('en') ? 'en-GB' : lang.startsWith('pt') ? 'pt-PT' : lang;

  let T = {};
  function readStrings() {
    const el = $('[data-fv-cart-i18n]');
    if (!el) return;
    try { T = JSON.parse(el.textContent); } catch (e) { T = {}; }
  }

  function money(cents) {
    const f = (window.MinimogSettings && MinimogSettings.money_format) || T.moneyFormat || '€{{amount_with_comma_separator}}';
    if (typeof window.formatMoney === 'function') {
      try { return window.formatMoney(cents, f); } catch (e) { /* fall through */ }
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ---------------- "Just added" ---------------- */
  const NEW_KEY = 'fv-cart-new';
  let newKey = null;
  let scrollToNew = false;
  try {
    const v = JSON.parse(sessionStorage.getItem(NEW_KEY) || 'null');
    if (v && Date.now() - v.t < 600000) newKey = v.k;
  } catch (e) { /* storage blocked */ }
  function setNew(k) {
    newKey = k;
    scrollToNew = true;
    try { sessionStorage.setItem(NEW_KEY, JSON.stringify({ k, t: Date.now() })); } catch (e) { /* ignore */ }
  }
  function clearNew() {
    newKey = null;
    try { sessionStorage.removeItem(NEW_KEY); } catch (e) { /* ignore */ }
  }
  function paintNew(d) {
    let hit = null;
    $$('.fv-bli', d).forEach((el) => {
      const on = !!newKey && el.dataset.key === newKey;
      el.classList.toggle('is-new', on);
      const tag = $('[data-fv-new]', el);
      if (tag) tag.hidden = !on;
      if (on) hit = el;
    });
    if (hit && scrollToNew) {
      scrollToNew = false;
      hit.scrollIntoView({ block: 'nearest', behavior: reduce() ? 'auto' : 'smooth' });
    }
  }

  /* ---------------- Deal countdown ---------------- */
  function left(s) {
    const p = (n) => String(n).padStart(2, '0');
    const d = Math.floor(s / 86400);
    const h = Math.floor((s % 86400) / 3600);
    const m = Math.floor((s % 3600) / 60);
    return (d > 0 ? d + (T.d || 'd') + ' ' : '') + p(h) + ':' + p(m) + ':' + p(s % 60);
  }
  function tick() {
    const d = drawer();
    if (!d) return;
    const now = Math.floor(Date.now() / 1000);
    $$('[data-fv-end]', d).forEach((el) => {
      const s = parseInt(el.dataset.fvEnd, 10) - now;
      const note = el.closest('.fv-bag__note');
      if (s <= 0) { if (note) note.hidden = true; return; }
      el.textContent = left(s);
    });
  }

  /* ---------------- Delivery dates (same rules as the product page) ---------------- */
  function lisbonNow() {
    try {
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Lisbon', hour: 'numeric', minute: 'numeric', weekday: 'short', hour12: false }).formatToParts(new Date());
      const get = (k) => (parts.find((x) => x.type === k) || {}).value;
      return { h: parseInt(get('hour'), 10) % 24, m: parseInt(get('minute'), 10), wd: get('weekday') };
    } catch (e) {
      const n = new Date();
      return { h: n.getHours(), m: n.getMinutes(), wd: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][n.getDay()] };
    }
  }
  function addWorkingDays(from, days) {
    const x = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    let n = days;
    while (n > 0) {
      x.setDate(x.getDate() + 1);
      if (x.getDay() !== 0 && x.getDay() !== 6) n -= 1;
    }
    return x;
  }
  function window_(el) {
    const min = parseInt(el.dataset.min, 10) || 0;
    const max = Math.max(parseInt(el.dataset.max, 10) || min, min);
    const cutoff = parseInt(el.dataset.cutoff, 10);
    const now = lisbonNow();
    const workday = now.wd !== 'Sat' && now.wd !== 'Sun';
    const beforeCut = !isNaN(cutoff) && workday && now.h < cutoff;
    let start = new Date();
    if (!isNaN(cutoff) && !beforeCut) start = addWorkingDays(start, 1);
    const da = addWorkingDays(start, min);
    const db = addWorkingDays(start, max);
    const fmt = new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'short' });
    const fmtDay = new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric' });
    const same = da.getMonth() === db.getMonth() && da.getFullYear() === db.getFullYear();
    const txt = min === max ? fmt.format(db) : (same ? fmtDay.format(da) : fmt.format(da)) + ' – ' + fmt.format(db);
    return { txt, beforeCut, now, cutoff, min };
  }
  function paintDates(d) {
    $$('[data-fv-arrive]', d).forEach((el) => {
      const w = window_(el);
      if (w.min > 0) el.textContent = fill(T.arrive, { d: w.txt });
    });
    $$('[data-fv-cut]', d).forEach((el) => {
      const w = window_(el);
      if (!w.beforeCut) { el.hidden = true; return; }
      const mins = (w.cutoff - w.now.h) * 60 - w.now.m;
      const t = (mins >= 60 ? Math.floor(mins / 60) + ' ' + (T.h || 'h') + ' ' : '') + (mins % 60) + ' ' + (T.m || 'min');
      const tt = $('[data-fv-cut-t]', el);
      const ts = $('[data-fv-cut-s]', el);
      if (tt) tt.textContent = t;
      if (ts) ts.textContent = fill(T.cutS, { d: w.txt });
      el.hidden = false;
    });
  }

  /* ---------------- Suggestions ---------------- */
  const cache = new Map();
  let recoToken = 0;
  let lastReco = { key: '', html: '' };
  async function getJSON(url) {
    const r = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error(String(r.status));
    return r.json();
  }
  async function recsFor(pid, intent) {
    const k = pid + ':' + intent;
    if (!cache.has(k)) {
      cache.set(k, getJSON(`${root()}recommendations/products.json?product_id=${pid}&limit=8&intent=${intent}`)
        .then((j) => j.products || [])
        .catch(() => []));
    }
    return cache.get(k);
  }
  function favHandles() {
    try {
      const a = JSON.parse(localStorage.getItem('m-wishlist-products') || '[]');
      return Array.isArray(a) ? a.filter(Boolean).slice(-8).reverse() : [];
    } catch (e) { return []; }
  }
  async function favProducts(skip) {
    const hs = favHandles().filter((h) => !skip.has(h));
    const list = await Promise.all(hs.map((h) => {
      const k = 'h:' + h;
      if (!cache.has(k)) cache.set(k, getJSON(`${root()}products/${encodeURIComponent(h)}.js`).catch(() => null));
      return cache.get(k);
    }));
    return list.filter(Boolean).map((p) => Object.assign({}, p, { _fav: true }));
  }
  function gapList(url, gap) {
    const k = 'g:' + url + ':' + gap;
    if (!cache.has(k)) {
      const q = `${url}${url.includes('?') ? '&' : '?'}filter.v.price.gte=${(gap / 100).toFixed(2)}&filter.v.availability=1&sort_by=price-ascending&section_id=fovory-bag-gap`;
      cache.set(k, fetch(q)
        .then((r) => (r.ok ? r.text() : ''))
        .then((t) => {
          const el = new DOMParser().parseFromString(t || '', 'text/html').querySelector('[data-fv-gap-json]');
          try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; }
        })
        .catch(() => []));
    }
    return cache.get(k);
  }
  async function gapProducts(url, gap) {
    const all = `${root()}collections/all`;
    let list = (await gapList(url || all, gap)).filter((p) => p.price >= gap);
    if (!list.length && url && !/\/collections\/all$/.test(url)) list = (await gapList(all, gap)).filter((p) => p.price >= gap);
    return list.slice(0, 3).map((p) => Object.assign({}, p, { _gap: true }));
  }
  const icon = {
    plus: '<svg class="fv-bsg__plus" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>',
    spin: '<svg class="fv-bsg__spin" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 3a9 9 0 1 0 9 9"/></svg>',
    x: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 7l10 10M17 7 7 17"/></svg>',
    truck: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 6.5h11v9.5H3z"/><path d="M14 9.5h3.6l3.4 3.4V16h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
    heart: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg>'
  };
  function card(p, reach) {
    const url = `${root()}products/${p.handle}`;
    let img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && typeof img === 'object') img = img.src || '';
    if (img.startsWith('//')) img = 'https:' + img;
    const src = img ? img + (img.includes('?') ? '&' : '?') + 'width=300' : '';
    const sale = p.compare_at_price && p.compare_at_price > p.price;
    const pct = sale ? Math.floor(((p.compare_at_price - p.price) * 100) / p.compare_at_price) : 0;
    const opts = (p.options || []).map((o) => (typeof o === 'string' ? o : o.name));
    const variants = p.variants || [];
    const avail = variants.filter((v) => v.available);
    const mode = variants.length === 1 && avail.length === 1 ? 'one' : opts.length === 1 ? 'size' : 'link';
    const label = esc(fill(T.add, { t: p.title }));
    let tags = '';
    if (p._fav) tags += `<span class="fv-bag-tag fv-bag-tag--fav">${icon.heart}${esc(T.fav)}</span>`;
    if (pct > 0) tags += `<span class="fv-bag-tag fv-bag-tag--sale">−${pct}%</span>`;
    const add = mode === 'link'
      ? `<a class="fv-bsg__add" href="${url}" aria-label="${label}">${icon.plus}</a>`
      : `<button type="button" class="fv-bsg__add" data-fv-add aria-label="${label}"${mode === 'size' ? ' aria-expanded="false"' : ''}>${icon.plus}${icon.spin}</button>`;
    const sizes = mode !== 'size' ? '' : `
      <div class="fv-bsg__sz" data-fv-sz role="group" aria-label="${esc(T.choose)}" hidden>
        <div class="fv-bsg__sz-h"><span>${esc(T.choose)}</span><button type="button" class="fv-bsg__sz-x" data-fv-sz-x aria-label="${esc(T.closeSizes)}">${icon.x}</button></div>
        <div class="fv-bsg__sz-g">${variants.map((v) => `<button type="button" data-fv-v="${v.id}"${v.available ? '' : ' disabled'}>${esc(v.option1 || v.title)}</button>`).join('')}</div>
      </div>`;
    return `<article class="fv-bsg" role="listitem" data-id="${p.id}" data-mode="${mode}" data-variant="${mode === 'one' ? avail[0].id : ''}">
      <div class="fv-bsg__media">
        <a class="fv-bsg__im" href="${url}" tabindex="-1" aria-hidden="true">${src ? `<img src="${esc(src)}" alt="" width="128" height="128" loading="lazy">` : ''}</a>
        ${tags ? `<span class="fv-bsg__tags">${tags}</span>` : ''}
        ${add}
      </div>
      <a class="fv-bsg__n" href="${url}"><span>${esc(p.title)}</span></a>
      <p class="fv-bsg__p${sale ? ' is-sale' : ''}">${money(p.price)}${sale ? `<s>${money(p.compare_at_price)}</s>` : ''}</p>
      ${reach ? `<p class="fv-bsg__reach">${icon.truck}${esc(T.freeTag)}</p>` : ''}
      ${sizes}
    </article>`;
  }
  async function reco(d) {
    const body = $('[data-fv-bag-data]', d);
    const sec = $('[data-fv-rc]', d);
    if (!body || !sec) return;
    const list = $('[data-fv-rc-list]', sec);
    const ds = body.dataset;
    const inCart = new Set((ds.fvInCart || '').split(',').filter(Boolean).map(Number));
    const inCartH = new Set((ds.fvInCartH || '').split(',').filter(Boolean));
    const gap = parseInt(ds.fvGap || '0', 10) || 0;
    const seeds = (ds.fvSeeds || '').split(',').filter(Boolean).slice(0, 2);
    const key = [ds.fvSeeds, ds.fvInCart, gap, favHandles().join(','), ds.fvReco, ds.fvFavs, ds.fvGapUrl].join('|');
    // Same bag as last time: put the cards back at once, no flash.
    if (key === lastReco.key) {
      list.innerHTML = lastReco.html;
      sec.hidden = !lastReco.html;
      return;
    }
    const token = ++recoToken;
    const gapP = gap > 0 ? await gapProducts(ds.fvGapUrl, gap) : [];
    const favs = ds.fvFavs === '1' ? await favProducts(inCartH) : [];
    let recs = [];
    if (ds.fvReco === '1' && seeds.length) {
      for (const pid of seeds) recs = recs.concat(await recsFor(pid, 'complementary'));
      if (recs.length < 4) for (const pid of seeds) recs = recs.concat(await recsFor(pid, 'related'));
    }
    if (token !== recoToken) return;
    const seen = new Set();
    const pick = [];
    gapP.concat(favs, recs).forEach((p) => {
      if (!p || seen.has(p.id) || inCart.has(p.id) || inCartH.has(p.handle) || !p.available) return;
      seen.add(p.id);
      pick.push(p);
    });
    // While delivery is not free: the cheapest pieces that close the gap first, then favourites,
    // then other pieces that also get there, then the rest.
    const reach = (p) => gap > 0 && p.price >= gap;
    const score = (p) => (p._gap ? 4 : 0) + (p._fav ? 2 : 0) + (reach(p) ? 1 : 0);
    pick.sort((a, b) => score(b) - score(a));
    const html = pick.slice(0, 8).map((p) => card(p, reach(p))).join('');
    lastReco = { key, html };
    const cur = $('[data-fv-rc]', drawer());
    if (!cur) return;
    $('[data-fv-rc-list]', cur).innerHTML = html;
    cur.hidden = !html;
  }

  /* ---------------- One-tap add ---------------- */
  async function add(id, cardEl) {
    if (!id || cardEl.classList.contains('is-busy')) return;
    cardEl.classList.add('is-busy');
    const old = $('.fv-bsg__err', cardEl);
    if (old) old.remove();
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } }));
    try {
      const r = await fetch(`${root()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sections.join(','), sections_url: location.pathname })
      });
      const j = await r.json();
      if (j.status || !j.items || !j.items.length) throw new Error(j.description || j.message || T.error);
      setNew(j.items[0].key);
      lastReco.key = '';
      if (window.MinimogEvents && window.MinimogTheme) {
        MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: j });
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      }
    } catch (e) {
      cardEl.classList.remove('is-busy');
      const sz = $('[data-fv-sz]', cardEl);
      if (sz) sz.hidden = true;
      const p = document.createElement('p');
      p.className = 'fv-bsg__err';
      p.setAttribute('role', 'alert');
      p.textContent = (e && e.message) || T.error;
      cardEl.appendChild(p);
    }
  }
  function openSizes(cardEl, open) {
    const sz = $('[data-fv-sz]', cardEl);
    const btn = $('[data-fv-add]', cardEl);
    if (!sz) return;
    $$('[data-fv-sz]', drawer()).forEach((x) => {
      if (x !== sz && !x.hidden) {
        x.hidden = true;
        const b = $('[data-fv-add]', x.closest('.fv-bsg'));
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
    sz.hidden = !open;
    if (btn) btn.setAttribute('aria-expanded', String(open));
    if (open) {
      const first = $('[data-fv-v]:not([disabled])', sz);
      if (first) first.focus({ preventScroll: true });
    } else if (btn) {
      btn.focus({ preventScroll: true });
    }
  }

  /* ---------------- Paint after every render ---------------- */
  let painted = 0;
  let opened = false;
  function paint() {
    const d = drawer();
    if (!d) return;
    paintNew(d);
    tick();
    paintDates(d);
    if (opened || isOpen()) reco(d);
    painted += 1;
  }

  /* ---------------- Open, close, focus, keys, swipe ---------------- */
  let returnTo = null;
  function onOpen() {
    const d = drawer();
    if (!d) return;
    opened = true;
    if (document.activeElement && !d.contains(document.activeElement)) returnTo = document.activeElement;
    const inner = $('.fv-bag__in', d);
    if (inner) inner.focus({ preventScroll: true });
    paint();
  }
  function onClass() {
    const d = drawer();
    if (!d) return;
    const active = d.classList.contains('m-cart-drawer--active');
    if (active && !d._fvActive) { d._fvActive = true; requestAnimationFrame(onOpen); }
    if (!active && d._fvActive) {
      d._fvActive = false;
      clearNew();
      $$('[data-fv-sz]', d).forEach((x) => { x.hidden = true; });
      if (returnTo && document.contains(returnTo)) returnTo.focus({ preventScroll: true });
      returnTo = null;
    }
  }
  function focusables(el) {
    return $$('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', el)
      .filter((x) => x.offsetParent !== null && !x.closest('[hidden]'));
  }
  function onKey(e) {
    if (!isOpen()) return;
    const d = drawer();
    if (e.key === 'Escape') {
      const sz = $$('[data-fv-sz]', d).find((x) => !x.hidden);
      if (sz) { openSizes(sz.closest('.fv-bsg'), false); return; }
      if (typeof d.close === 'function') d.close();
      return;
    }
    if (e.key === 'Tab') {
      const inner = $('.fv-bag__in', d);
      const f = focusables(inner);
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === inner)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
  function onClick(e) {
    const d = drawer();
    if (!d || !d.contains(e.target)) return;
    const q = e.target.closest('[data-fv-q]');
    if (q) {
      const row = q.closest('.fv-bli');
      const items = document.getElementById('MinimogCartDrawerBody');
      if (!row || !items || typeof items.updateQuantity !== 'function') return;
      const qty = Math.max(0, parseInt(q.dataset.fvQ, 10) || 0);
      const out = $('output', row);
      if (out) out.textContent = qty;
      $$('[data-fv-q]', row).forEach((b) => { b.disabled = true; });
      items.updateQuantity(row.dataset.line, qty);
      return;
    }
    const a = e.target.closest('[data-fv-add]');
    if (a) {
      const c = a.closest('.fv-bsg');
      if (c.dataset.mode === 'one') add(c.dataset.variant, c);
      else openSizes(c, true);
      return;
    }
    const x = e.target.closest('[data-fv-sz-x]');
    if (x) { openSizes(x.closest('.fv-bsg'), false); return; }
    const v = e.target.closest('[data-fv-v]');
    if (v) add(v.dataset.fvV, v.closest('.fv-bsg'));
  }
  function swipe(d) {
    const inner = $('.fv-bag__in', d);
    if (!inner) return;
    let y0 = null;
    let dy = 0;
    const phone = () => window.matchMedia('(max-width: 767px)').matches;
    inner.addEventListener('pointerdown', (e) => {
      if (!phone() || e.button > 0) return;
      if (!e.target.closest('[data-fv-bag-grab], .fv-bag__hd') || e.target.closest('button, a')) return;
      y0 = e.clientY;
      dy = 0;
      inner.style.transition = 'none';
      try { inner.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
    });
    inner.addEventListener('pointermove', (e) => {
      if (y0 == null) return;
      dy = Math.max(0, e.clientY - y0);
      inner.style.transform = `translate3d(0, ${dy}px, 0)`;
    });
    const end = () => {
      if (y0 == null) return;
      y0 = null;
      inner.style.transition = '';
      inner.style.transform = '';
      if (dy > 96 && typeof d.close === 'function') d.close();
    };
    inner.addEventListener('pointerup', end);
    inner.addEventListener('pointercancel', end);
  }

  function hookEvents(tries = 0) {
    if (!window.MinimogEvents || !window.MinimogTheme) {
      if (tries < 50) setTimeout(() => hookEvents(tries + 1), 200);
      return;
    }
    const ev = MinimogTheme.pubSubEvents;
    MinimogEvents.subscribe(ev.cartUpdate, (e) => {
      const c = e && e.cart;
      // A product form add answers with the line item itself (it has a key and no cart token).
      if (c && c.key && c.variant_id && !c.token) setNew(c.key);
    });
  }

  function init() {
    const d = drawer();
    if (!d || d._fvInit) return;
    d._fvInit = true;
    readStrings();
    let t = null;
    const later = () => { clearTimeout(t); t = setTimeout(paint, 20); };
    const mo = new MutationObserver(later);
    ['MinimogCartDrawerHeader', 'MinimogCartDrawerBody', 'MinimogCartDrawerFooter'].forEach((id) => {
      const el = document.getElementById(id);
      if (el) mo.observe(el, { childList: true });
    });
    new MutationObserver(onClass).observe(d, { attributes: true, attributeFilter: ['class'] });
    d.addEventListener('click', onClick);
    document.addEventListener('keydown', onKey);
    swipe(d);
    hookEvents();
    paint();
    setInterval(() => { if (isOpen()) tick(); }, 1000);
    setInterval(() => { if (isOpen()) paintDates(drawer()); }, 30000);
    window.FovoryCart = { paint, reco: () => reco(drawer()) };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
